import React from "react";
import styled from "styled-components";
import Spinner from "react-bootstrap/Spinner";
import { BigBlueButton } from "../../../profile/components/Buttons";
import { requestCampaignNotification } from "../../actions";
import { connect } from "react-redux";
import { GlobalState } from "../../../reducers";

const HeaderButton = styled(BigBlueButton)<{ disabled?: boolean }>`
    user-select: none;
    ${props => props.disabled && `pointer-events: none; opacity: 0.5;`}
`;

interface Props {
    currentCampaign: number | null;
    accessLoading: boolean;
    requestCampaignNotification: (campaignId: number) => void;
}

const NotifyButton = ({
    currentCampaign,
    accessLoading,
    requestCampaignNotification
}: Props) => {
    const currentNotifs = JSON.parse(
        localStorage.getItem("campaignNotification") || "{}"
    );
    if (accessLoading)
        return (
            <HeaderButton disabled>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                />
            </HeaderButton>
        );
    return (
        <HeaderButton
            disabled={currentCampaign && currentNotifs[currentCampaign]}
            onClick={() => {
                currentCampaign && requestCampaignNotification(currentCampaign);
            }}
        >
            Notify when available
        </HeaderButton>
    );
};

const mapStateToProps = (state: GlobalState) => ({
    currentCampaign: state.ui.campaign.currentCampaignId,
    accessLoading: state.ui.campaign.accessLoading
});

const mapDispatchToProps = (dispatch: any) => ({
    requestCampaignNotification: (campaignId: number) =>
        dispatch(requestCampaignNotification(campaignId))
});

export default connect(mapStateToProps, mapDispatchToProps)(NotifyButton);
